module.exports = __webpack_public_path__ + "img/y_reject.0ce0fca2.png";